import { useQuery } from '@tanstack/react-query';
import { getCommunicationPreferences } from 'common/communication-preferences.api';
import { serverToValues } from './communication-preferences.mappers';

export const COMMUNICATION_PREFERENCES_QUERY_KEY = ['communicationPreferences'];

/**
 * Loads the member's communication preferences and maps the server shape into
 * the form's `CommunicationPreferencesValues` via `select`.
 *
 * Intentional deviation from the GEIS-359 AC: there is no plan-switch refetch.
 * Data loads once on screen entry, matching geisinger-ios. If multi-plan
 * support lands, wire a plan id into the query key here.
 */
export const useCommunicationPreferencesQuery = () =>
  useQuery({
    queryKey: COMMUNICATION_PREFERENCES_QUERY_KEY,
    queryFn: getCommunicationPreferences,
    select: serverToValues,
    // One quick retry, then surface the error — avoids React Query's default
    // 3-retry exponential backoff (~7s) before the error state shows. Matches
    // cigna-web's communication-preferences query.
    retry: 1,
  });
